import { render, staticRenderFns } from "./orgCreat.vue?vue&type=template&id=59e6a572&scoped=true&"
import script from "./orgCreat.vue?vue&type=script&lang=js&"
export * from "./orgCreat.vue?vue&type=script&lang=js&"
import style0 from "./orgCreat.vue?vue&type=style&index=0&id=59e6a572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e6a572",
  null
  
)

export default component.exports